import { useEffect, useState } from "react";
import {
  ImageWheel,
  ImageWheelContainer,
  ImageWheelGradientOverlay,
  TextCard,
  TextCardButton,
  TextCardButtonLink,
  TextCardIntroTitle,
  TextCardText,
  TextCardTitle,
} from "./ImagewheelStyles";
import { Link } from "react-router-dom";

function Imagewheel({
  isHome = false,
  isAbout = false,
  isContact = false,
  isWork = false,
  isVacancy = false,
  isFlex = false,
  isCrisis = false,
  isPlanning = false,
  images,
}) {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  /**
   * Rotate homepage images
   */
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex(
        (currentImageIndex) => (currentImageIndex + 1) % images.length
      );
    }, 5000);

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <ImageWheelContainer $isHome={isHome}>
      {images.map((src, index) => (
        <ImageWheel
          key={index}
          src={src}
          alt="Smart Personeel"
          $isActive={index === currentImageIndex}
          $isHome={isHome}
        />
      ))}

      <ImageWheelGradientOverlay $isHome={isHome} />

      {isHome && (
        <TextCard $isHome={true}>
          <TextCardIntroTitle>Better Work, Better Life!</TextCardIntroTitle>
          <TextCardTitle>Smart oplossingen</TextCardTitle>
          <TextCardText>
            Smart-Personeel biedt slimme oplossingen voor de zorgsector. Met
            jarenlange ervaring en een uitgebreid netwerk van zorgprofessionals
            staan we klaar om de juiste ondersteuning te bieden. Wij zorgen voor
            continuïteit, kwaliteit en flexibiliteit. Samen bouwen we aan een
            efficiënte en toekomstbestendige zorg.
          </TextCardText>
          <TextCardButtonLink as={Link} to="/healthcare/work">
            <TextCardButton>Direct aanmelden</TextCardButton>
          </TextCardButtonLink>
          <TextCardButtonLink as={Link} to="/healthcare/vacancy">
            <TextCardButton>Alle vacatures</TextCardButton>
          </TextCardButtonLink>
        </TextCard>
      )}

      {isAbout && (
        <TextCard $isHome={false}>
          <TextCardIntroTitle>Better Work, Better Life!</TextCardIntroTitle>
          <TextCardTitle style={{ marginTop: "30px" }}>Over ons</TextCardTitle>
          <TextCardText style={{ marginTop: "30px" }}>
            Bij Smart Personeel geloven we dat de juiste match tussen werkgever
            en werknemer het verschil maakt. Sinds onze oprichting hebben we ons
            ingezet om bedrijven te voorzien van gekwalificeerde en gemotiveerde
            professionals, en om talenten te helpen bij het vinden van hun
            ideale werkplek.
          </TextCardText>
        </TextCard>
      )}

      {isContact && (
        <TextCard $isHome={false}>
          <TextCardIntroTitle>Better Work, Better Life!</TextCardIntroTitle>
          <TextCardTitle style={{ marginTop: "30px" }}>Contact</TextCardTitle>
          <TextCardText style={{ marginTop: "30px" }}>
            Heeft u vragen of wilt u meer weten over de slimme oplossingen die
            wij bieden? Neem gerust contact met ons op. Ons team staat klaar om
            u te helpen en samen te werken aan de toekomstbestendige zorg die uw
            organisatie nodig heeft. Wij luisteren graag naar uw behoeften en
            zoeken naar de beste oplossingen voor zowel werkgevers als
            werknemers.
          </TextCardText>
        </TextCard>
      )}

      {isWork && (
        <TextCard $isHome={false}>
          <TextCardIntroTitle>Better Work, Better Life!</TextCardIntroTitle>
          <TextCardTitle style={{ marginTop: "30px" }}>
            Direct aanmelden!
          </TextCardTitle>
          <TextCardText style={{ marginTop: "30px" }}>
            Bij Smart-Personeel bieden we zorgprofessionals flexibele
            werkopties. Kies de werkstructuur die het beste bij jou past! Ontdek
            hieronder meer over de drie mogelijkheden: werken als zzp’er, in
            loondienst of een combinatie van beiden.
          </TextCardText>
        </TextCard>
      )}

      {isVacancy && (
        <TextCard $isHome={false}>
          <TextCardIntroTitle>Better Work, Better Life!</TextCardIntroTitle>
          <TextCardTitle style={{ marginTop: "30px" }}>Vacatures</TextCardTitle>
          <TextCardText style={{ marginTop: "30px" }}>
            Smart Flex biedt een flexibele schil van zorgprofessionals, precies
            waar en wanneer u ze nodig heeft. Uitzendkrachten of zzp’ers, wij
            zorgen voor de juiste ondersteuning op het juiste moment.
          </TextCardText>
        </TextCard>
      )}

      {isFlex && (
        <TextCard $isHome={false}>
          <TextCardIntroTitle>Better Work, Better Life!</TextCardIntroTitle>
          <TextCardTitle style={{ marginTop: "30px" }}>
            Smart Flex
          </TextCardTitle>
          <TextCardText style={{ marginTop: "30px" }}>
            Smart Flex biedt een flexibele schil van zorgprofessionals, precies
            waar en wanneer u ze nodig heeft. Uitzendkrachten of zzp’ers, wij
            zorgen voor de juiste ondersteuning op het juiste moment.
          </TextCardText>
        </TextCard>
      )}

      {isCrisis && (
        <TextCard $isHome={false}>
          <TextCardIntroTitle>Better Work, Better Life!</TextCardIntroTitle>
          <TextCardTitle style={{ marginTop: "30px" }}>
            Smart Crisis Team
          </TextCardTitle>
          <TextCardText style={{ marginTop: "30px" }}>
            Ons Smart Crisis Team biedt direct inzetbare zorgprofessionals die
            een locatie tijdelijk overnemen en de zorg herstructureren. Wij
            zorgen voor stabiliteit, expertise en rust, zodat u weer met
            vertrouwen verder kunt.
          </TextCardText>
        </TextCard>
      )}

      {isPlanning && (
        <TextCard $isHome={false}>
          <TextCardIntroTitle>Better Work, Better Life!</TextCardIntroTitle>
          <TextCardTitle style={{ marginTop: "30px" }}>
            Smart Planning
          </TextCardTitle>
          <TextCardText style={{ marginTop: "30px" }}>
            Smart Planning biedt zorgplanners die direct bij instellingen aan de
            slag kunnen. Ze brengen structuur in roosters, regelen de bezetting
            en lossen tekorten op. Wij bieden meer dan alleen extra handen op de
            werkvloer – wel zo smart!
          </TextCardText>
        </TextCard>
      )}
    </ImageWheelContainer>
  );
}

export default Imagewheel;
